import { EventEmitter, Injectable, Output } from '@angular/core';
import { HttpService } from 'gast-common-ng';
import { UrlService } from './url.service';
import { GastRequestModel } from 'gast-common-ng/lib/shared/models/gast-request.model';
import { ResultDto } from '../dto/result-dto';
import { VerificationTestdafFormDto } from '../dto/verification-testdaf-form.dto';
import { GastRequestWithBodyModel } from 'gast-common-ng/lib/shared/models/gast-request-with-body.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { VerificationTestasFormDto } from '../dto/verification-testas-form.dto';
import { VerificationDmatFormDto } from '../dto/verification-dmat-form.dto';
import { VerificationDtzFormDto } from '../dto/verification-dtz-form.dto';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { VerificationDtzFromCertificateDto } from '../dto/verification-dtz-from-certificate.dto';
import { TestasDigitalResultDto } from '../dto/testas-digital-result.dto';
import { DmatModuleDto } from '../dto/dmat-module.dto';
import { VerificationBestOfCertificateDto } from '../dto/verification-best-of-certificate-testdaf.dto';


export class RecaptchaVerificationDto {

  captchaVerificationResult: boolean;
  sessionId: string;
}

@Injectable()
export class CertificateService {

  @Output() resultLoaded: EventEmitter<ResultDto> = new EventEmitter();
  @Output() resultDtzByQrCodeLoaded: EventEmitter<VerificationDtzFormDto> = new EventEmitter();
  @Output() testdafDigitalResultLoaded: EventEmitter<ResultDto> = new EventEmitter();
  @Output() verificationError: EventEmitter<any> = new EventEmitter();
  @Output() testasDigitalResultLoaded: EventEmitter<boolean> = new EventEmitter();
  @Output() testasDigitalQrResultLoaded: EventEmitter<TestasDigitalResultDto> = new EventEmitter();
  @Output() dmatDigitalResultLoaded: EventEmitter<boolean> = new EventEmitter();
  @Output() dmatDigitalQrResultLoaded: EventEmitter<TestasDigitalResultDto> = new EventEmitter();
  @Output() dmatModulesLoaded: EventEmitter<Array<DmatModuleDto>> = new EventEmitter();
  @Output() dmatModulesError: EventEmitter<any> = new EventEmitter();
  @Output() dtzResultLoaded: EventEmitter<boolean> = new EventEmitter();
  @Output() recaptchaVerificationLoaded: EventEmitter<RecaptchaVerificationDto> = new EventEmitter();
  @Output() resultDtzByUploadedPdfLoaded: EventEmitter<VerificationDtzFromCertificateDto> = new EventEmitter();
  @Output() resultDtzByUploadedPdfError: EventEmitter<boolean> = new EventEmitter();

  @Output() resultTestdafBestofCertificateByQrCodeLoaded: EventEmitter<VerificationBestOfCertificateDto> = new EventEmitter();
  @Output() resultTestdafBestofCertificateByFormLoaded: EventEmitter<VerificationBestOfCertificateDto> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private httpService: HttpService,
    private urlService: UrlService,
    private spinnerService: NgxSpinnerService,
    private toastr: ToastrService) {
  }

  public getResults(token: string, hash: string) {
    this.httpService.get({
      mapper: (response: Response) => response.json() as any,
      callback: (result: ResultDto) => this.resultLoaded.emit(result),
      url: this.urlService.getCertificateVerification() + '?token=' + token + '&hash=' + hash
    } as GastRequestModel<any>);
  }

  public getTestdafDigitalResults(token: string, hash: string) {
    this.httpService.get({
      mapper: (response: Response) => response.json() as any,
      callback: (result: ResultDto) => this.testdafDigitalResultLoaded.emit(result),
      url: this.urlService.getTestdafDigitalCertificateVerification() + '?token=' + token + '&hash=' + hash
    } as GastRequestModel<any>);
  }

  public getTestdafDigitalFormResults(dto: VerificationTestdafFormDto) {
    const errorCallback = () => {
      this.verificationError.emit();
      this.spinnerService.hide();
    };
    this.httpService.post({
      body: dto,
      mapper: (response: Response) => response.json() as any,
      callback: (result: ResultDto) => this.testdafDigitalResultLoaded.emit(result),
      url: this.urlService.getTestdafDigitalFormCertificateVerification()
    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }

  public getTestdafPaperbasedFormResults(dto: VerificationTestdafFormDto) {
    const errorCallback = () => {
      this.spinnerService.hide();
    };
    this.httpService.post({
      body: dto,
      mapper: (response: Response) => response.json() as any,
      callback: (result: ResultDto) => this.testdafDigitalResultLoaded.emit(result),
      url: this.urlService.getTestdafPaperbasedFormCertificateVerification()
    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }

  getTestasDigitalFormResults(dto: VerificationTestasFormDto) {
    const errorCallback = () => {
      this.verificationError.emit();
      this.spinnerService.hide();
    };
    this.httpService.post({
      body: dto,
      mapper: (response: Response) => response.json() as any,
      callback: (result: boolean) => this.testasDigitalResultLoaded.emit(result),
      url: this.urlService.getTestasDigitalFormCertificateVerification()
    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }

  getTestasPaperbasedFormResults(dto: VerificationTestasFormDto) {
    const errorCallback = () => {
      this.verificationError.emit();
      this.spinnerService.hide();
    };
    this.httpService.post({
      body: dto,
      mapper: (response: Response) => response.json() as any,
      callback: (result: boolean) => this.testasDigitalResultLoaded.emit(result),
      url: this.urlService.getTestasPaperbasedFormCertificateVerification()
    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }

  public getTestasDigitalResults(token: string, hash: string) {
    const url = this.urlService.getTestasDigitalCertificateVerification() + '?token=' + token + '&hash=' + hash;
    this.http.get<TestasDigitalResultDto>(url, { withCredentials: true }).subscribe(
      (result: TestasDigitalResultDto) => this.testasDigitalQrResultLoaded.emit(result),
      () => this.verificationError.emit());
  }

  getDmatDigitalFormResults(dto: VerificationDmatFormDto) {
    const errorCallback = () => {
      this.verificationError.emit();
      this.spinnerService.hide();
    };
    this.httpService.post({
      body: dto,
      mapper: (response: Response) => response.json() as any,
      callback: (result: boolean) => this.dmatDigitalResultLoaded.emit(result),
      url: this.urlService.getDmatDigitalFormCertificateVerification()
    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }

  public getDmatDigitalResults(token: string, hash: string) {
    const url = this.urlService.getDmatDigitalCertificateVerification() + '?token=' + token + '&hash=' + hash;
    this.http.get<TestasDigitalResultDto>(url, { withCredentials: true }).subscribe(
      (result: TestasDigitalResultDto) => this.dmatDigitalQrResultLoaded.emit(result),
      () => this.verificationError.emit());
  }

  public getDmatModules() {
    this.http.get<Array<DmatModuleDto>>(this.urlService.getDmatModules(), { withCredentials: true }).subscribe(
      (result: Array<DmatModuleDto>) => this.dmatModulesLoaded.emit(result),
      () => this.dmatModulesError.emit());
  }

  public getDtzFormResults(dto: VerificationDtzFormDto) {

    const errorCallback = () => {

      this.verificationError.emit();
    };

    this.httpService.post({

      body: dto,
      mapper: (response: Response) => response.json() as any,
      callback: (result: boolean) => this.dtzResultLoaded.emit(result),
      url: this.urlService.getDtzFormCertificateVerification()

    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }

  public dtzCertificateVerifyUser(captchaGoogleToken: string): void {

    const url = this.urlService.getDtzCertificateVerifyUser();

    let httpParams;

    if (captchaGoogleToken != null) {

      httpParams = new HttpParams().set('g-recaptcha-response', captchaGoogleToken);
    }

    const httpOptions = {

      withCredentials: true,
      params: httpParams
    };

    this.http.post<RecaptchaVerificationDto>(url, null, httpOptions).subscribe(
      (response: RecaptchaVerificationDto) => {

        this.recaptchaVerificationLoaded.emit(response);
      },

      (err: HttpErrorResponse) => {

        // tslint:disable-next-line:no-string-literal
        if (err.error['code'] === 'RECAPTCHA_INVALID') {
          // ?
        }

        this.verificationError.emit(err);
      });
  }

  public getDtzQrCodeResults(token: string, hash: number): void {
    this.httpService.post({
      mapper: (response: Response) => response.json() as any,
      callback: (result: VerificationDtzFormDto) => this.resultDtzByQrCodeLoaded.emit(result),
      url: this.urlService.getDtzCertificateVerificationByQrCode() + '?token=' + token + '&hash=' + hash
    } as GastRequestWithBodyModel<any, any>, () => this.resultDtzByQrCodeLoaded.emit());
  }

  public getCertificateDataFromPdf(pdf: any): void {

    const callback = (result: VerificationDtzFromCertificateDto) => this.resultDtzByUploadedPdfLoaded.emit(result);

    const errorCallback = () => {

      this.spinnerService.hide();
      this.resultDtzByUploadedPdfError.emit(true);
      this.toastr.error('Es ist ein technischer Fehler vorgekommen.');
    };

    this.httpService.post({

      body: pdf,
      mapper: (response: Response) => response.json() as any,
      // tslint:disable-next-line:object-literal-shorthand
      callback: callback,
      url: this.urlService.getCertificateDataFromPdfUrl()

    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }

  public getTestdafBestOfCertificateVerificationByQrCode(token: string): void {
    this.httpService.get({
      mapper: (response: Response) => response.json() as any,
      callback: (result: VerificationBestOfCertificateDto) => this.resultTestdafBestofCertificateByQrCodeLoaded.emit(result),
      url: this.urlService.getTestdafBestOfCertificateVerificationByQrCode() + '?token=' + token
    } as GastRequestModel<any>);
  }

  public getTestdafBestOfCertificateVerificationByForm(dto: VerificationBestOfCertificateDto): void {
    const errorCallback = () => {
      this.verificationError.emit();
      this.spinnerService.hide();
    };
    this.httpService.post({
      body: dto,
      mapper: (response: Response) => response.json() as any,
      callback: (result: VerificationBestOfCertificateDto) => this.resultTestdafBestofCertificateByFormLoaded.emit(result),
      url: this.urlService.getTestdafBestOfCertificateVerificationForm()
    } as GastRequestWithBodyModel<any, any>, errorCallback);
  }
}
